export var PayoutType;
(function (PayoutType) {
    PayoutType["bankTransfer"] = "API-IBAN";
    PayoutType["paypal"] = "API-PAYPAL";
    PayoutType["localStore"] = "LOCAL-STORE-PAYOUT";
})(PayoutType || (PayoutType = {}));
